interface Props {
  onSkip: () => void;
  onAddGames: () => void;
}

export function AddGamesPrompt({ onSkip, onAddGames }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center">
      <div className="w-full max-w-phone rounded-2xl bg-paper p-5 shadow-bt">
        <div className="font-serif text-xl font-bold text-ink">Add games?</div>
        <p className="mt-2 text-sm leading-relaxed text-ink-soft">
          Track Nassau, Skins, and more — pick more than one if you like. Or skip and just keep score.
        </p>
        <div className="mt-5 flex flex-col gap-2">
          <button
            type="button"
            onClick={onAddGames}
            className="w-full rounded-xl bg-navy py-3.5 text-sm font-bold text-cream"
          >
            Add Games
          </button>
          <button
            type="button"
            onClick={onSkip}
            className="w-full rounded-xl border border-line py-3.5 text-sm font-bold text-ink-soft"
          >
            Skip — just play
          </button>
        </div>
      </div>
    </div>
  );
}
